// extracted by mini-css-extract-plugin
module.exports = {"row":"simple-table_row__XvfRf","removeHighlightOnHover":"simple-table_removeHighlightOnHover__14rEY"};